import { Howl } from 'howler';
import { createContext, useEffect, useState } from 'react';

export const AudioContext = createContext();

export const AudioProvider = ({ children }) => {
  const [audioPermission, setAudioPermission] = useState(false);
  const [sounds, setSounds] = useState({});

  const SOUNDS = [
    {
      name: 'door-enter',
      volume: 0.2,
    },
    {
      name: 'computer-hover',
      volume: 1.0,
    },
    {
      name: 'curtain-open',
      volume: 1.0,
    },
    {
      name: 'curtain-hover',
      volume: 1.0,
    },
    {
      name: 'paper',
      volume: 1.0,
    },

    {
      name: 'door-open',
      volume: 0.2,
    },
    {
      name: 'door-close',
      volume: 0.2,
    },
    {
      name: 'old-1',
      volume: 1,
    },
    {
      name: 'old-hover-1',
      volume: 1,
    },
    {
      name: 'old-hover-2',
      volume: 1,
    },
    {
      name: 'old-hover-3',
      volume: 1,
    },
    {
      name: 'lady-1',
      volume: 1,
    },
    {
      name: 'bonichan',
      volume: 1,
    },
    {
      name: 'go-backroom',
      volume: 1,
    },
    {
      name: 'bot-1',
      volume: 1,
    },
    {
      name: 'bot-2',
      volume: 1,
    },
    {
      name: 'old-2',
      volume: 1,
    },

    {
      name: 'hover',
      volume: 1,
    },
    {
      name: 'bgm',
      volume: 0.2,
      loop: true,
    },
  ];

  const enableAudio = () => {
    if (audioPermission) {
      SOUNDS?.forEach(sound => stopSound(sound.name));
      setSounds({});
    }
    setAudioPermission(!audioPermission);
  };

  const playSound = soundName => {
    if (audioPermission && sounds[soundName]) {
      sounds[soundName].play();
    }
  };

  const stopSound = soundName => {
    if (audioPermission && sounds[soundName]) {
      sounds[soundName].stop();
    }
  };

  useEffect(() => {
    if (audioPermission) {
      const soundObject = {};
      SOUNDS.forEach(sound => {
        soundObject[sound.name] = new Howl({ src: [require(`../../assets/sounds/${sound.name}.mp3`)], volume: sound.volume, loop: Boolean(sound.loop) });
      });
      setSounds(soundObject);
    }
  }, [audioPermission]);

  return <AudioContext.Provider value={{ audioPermission, enableAudio, playSound, stopSound }}>{children}</AudioContext.Provider>;
};
